
export function highlightTaggedUsersInHtml(html: string): string {
  if (!html) return '';

  if (typeof window === 'undefined' || typeof DOMParser === 'undefined') {
    return html.replace(/@(\w+)/g, '<span class="tagged-user">@$1</span>');
  }

  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const mentionRe = /@(\w+)/g;

    const walk = (node: Node): void => {
      if (node.nodeType === Node.TEXT_NODE) {
        const text = node.textContent ?? '';
        if (!text.includes('@')) return;

        const matches = [...text.matchAll(mentionRe)];
        if (matches.length === 0) return;

        const fragment = document.createDocumentFragment();
        let lastIndex = 0;
        for (const m of matches) {
          const start = m.index ?? 0;
          if (start > lastIndex) {
            fragment.appendChild(document.createTextNode(text.slice(lastIndex, start)));
          }
          const span = document.createElement('span');
          span.className = 'tagged-user';
          span.textContent = m[0];
          fragment.appendChild(span);
          lastIndex = start + m[0].length;
        }
        if (lastIndex < text.length) {
          fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
        }

        const parent = node.parentNode;
        if (parent) {
          parent.replaceChild(fragment, node);
        }
        return;
      }

      if (node.nodeType !== Node.ELEMENT_NODE) return;

      const tag = (node as Element).tagName;
      if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'TEXTAREA') return;

      const children = Array.from(node.childNodes);
      for (const child of children) {
        walk(child);
      }
    };

    for (const child of Array.from(doc.body.childNodes)) {
      walk(child);
    }

    return doc.body.innerHTML;
  } catch {
    return html.replace(/@(\w+)/g, '<span class="tagged-user">@$1</span>');
  }
}
